import React from 'react';
import { roles } from '../utils/enum/roleType';

//Importing Components
const ForgotPassword = React.lazy(() => import('../pages/ResetPassword/ForgotPassword'));
const Agents = React.lazy(() => import('../pages/Agents'));
const CompanyRegistration = React.lazy(() => import('../pages/ManageUsers/CompanyRegistration'));
const ProcessCurrentStatus = React.lazy(() => import('../pages/ProcessCurrentStatus'));
const HistoryLogs = React.lazy(() => import('../pages/HistoryLogs'));
const Dashboard = React.lazy(() => import('../pages/Dashboard/Dashboard'));
const UserRegistration = React.lazy(() => import('../pages/ManageUsers/UserRegistration'));
const Login = React.lazy(() => import('../pages/Login'));
const Home = React.lazy(() => import('../components/Home'));
const CreateBot = React.lazy(() => import('../components/Bots/CreateBot'));
const ViewBots = React.lazy(() => import('../components/Bots/ViewBots'));
const Users = React.lazy(() => import('../pages/ManageUsers/Users'));
const UserDetails = React.lazy(() => import('../pages/ManageUsers/UserDetails'));
const Companies = React.lazy(() => import('../pages/ManageUsers/Companies'));
const CompanyDetails = React.lazy(() => import('../pages/ManageUsers/CompanyDetails'));
const ScheduledPlans = React.lazy(() => import('../pages/ScheduledPlans'));
const ScheduledPlanDetails = React.lazy(
  () => import('../pages/ScheduledPlanDetails')
);
const ScheduledHistory = React.lazy(() => import('../pages/ScheduledHistory'));
const Groups = React.lazy(() => import('../pages/ManageUsers/Groups'));
const GroupRegistration = React.lazy(
  () => import('../pages/ManageUsers/GroupRegistration/GroupRegistration')
);
const GroupDetails = React.lazy(() => import('../pages/ManageUsers/GroupDetails/GroupDetails'));
// const ProfileDetails = React.lazy(() => import('../components/ProfilePage/ProfileDetails'));
const ProfileDetails = React.lazy(() => import('../pages/Profile'));
const ProcessLogsDetails = React.lazy(
  () => import('../pages/ProcessCurrentStatus/ProcessLogsDetails')
);
const ManageUsers = React.lazy(() => import('../pages/ManageUsers'));
const ROIConfiguration = React.lazy(() => import('../pages/ROIConfiguration'));

//Defining User Role Based Routes
const routes = {
  [roles.SuperAdmin]: [
    {
      key: 1,
      path: '/controlroom',
      exact: true,
      component: Dashboard,
    },
    {
      key: 2,
      path: '/controlroom/agents',
      exact: true,
      component: Agents,
    },
    {
      key: 4,
      path: '/controlroom/process',
      exact: true,
      component: ProcessCurrentStatus,
    },
    {
      key: 5,
      path: '/controlroom/process/logs',
      exact: true,
      component: HistoryLogs,
    },
    {
      key: 55,
      path: '/controlroom/user/registration',
      exact: true,
      component: UserRegistration,
    },
    {
      key: 9,
      path: '/controlroom/bots/create',
      exact: true,
      component: CreateBot,
    },
    {
      key: 10,
      path: '/controlroom/bots/view',
      exact: true,
      component: ViewBots,
    },
    {
      key: 12,
      path: '/controlroom/user/view',
      exact: true,
      component: Users,
    },
    {
      key: 13,
      path: '/controlroom/user/details/:id',
      exact: true,
      component: UserDetails,
    },
    {
      key: 15,
      path: '/controlroom/process/schedule/all',
      exact: true,
      component: ScheduledPlans,
    },
    {
      key: 16,
      path: '/controlroom/process/schedule/history',
      exact: true,
      component: ScheduledHistory,
    },
    {
      key: 25,
      component: CompanyRegistration,
      exact: true,
      path: '/controlroom/company/register',
    },
    {
      key: 17,
      path: '/controlroom/process/schedule/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 18,
      path: '/controlroom/process/schedule/history/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 57,
      path: '/controlroom/company/view',
      exact: true,
      component: Companies,
    },
    {
      key: 58,
      path: '/controlroom/company/details/:id',
      exact: true,
      component: CompanyDetails,
    },
    {
      key: 60,
      path: '/controlroom/groups',
      exact: true,
      component: Groups,
    },
    {
      key: 611,
      path: '/controlroom/group/registration',
      exact: true,
      component: GroupRegistration,
    },
    {
      key: 62,
      path: '/controlroom/groups/details/:id',
      exact: true,
      component: GroupDetails,
    },
    {
      key: 61,
      path: '/controlroom/profile',
      exact: true,
      component: ProfileDetails,
    },
    {
      key: 6,
      path: '/controlroom/process/:processDetails/:id',
      exact: true,
      component: ProcessLogsDetails,
    },
    {
      key: 612,
      path: '/controlroom/user',
      exact: true,
      component: ManageUsers,
    },
    {
      key: 613,
      path: '/controlroom/roi-configuration',
      exact: true,
      component: ROIConfiguration,
    },
    {
    key: 111,
    path: '/controlroom/:companyId',
    exact: true,
    component: Dashboard,
  }
  ],
  [roles.SubAdmin]: [
    {
      key: 1,
      path: '/controlroom',
      exact: true,
      component: Dashboard,
    },
    {
      key: 2,
      path: '/controlroom/agents',
      exact: true,
      component: Agents,
    },
    {
      key: 4,
      path: '/controlroom/process',
      exact: true,
      component: ProcessCurrentStatus,
    },
    {
      key: 5,
      path: '/controlroom/process/logs',
      exact: true,
      component: HistoryLogs,
    },
    {
      key: 55,
      path: '/controlroom/user/registration',
      exact: true,
      component: UserRegistration,
    },
    {
      key: 9,
      path: '/controlroom/bots/create',
      exact: true,
      component: CreateBot,
    },
    {
      key: 10,
      path: '/controlroom/bots/view',
      exact: true,
      component: ViewBots,
    },
    {
      key: 12,
      path: '/controlroom/user/view',
      exact: true,
      component: Users,
    },
    {
      key: 13,
      path: '/controlroom/user/details/:id',
      exact: true,
      component: UserDetails,
    },
    {
      key: 15,
      path: '/controlroom/process/schedule/all',
      exact: true,
      component: ScheduledPlans,
    },
    {
      key: 16,
      path: '/controlroom/process/schedule/history',
      exact: true,
      component: ScheduledHistory,
    },
    {
      key: 25,
      component: CompanyRegistration,
      exact: true,
      path: '/controlroom/company/register',
    },
    {
      key: 17,
      path: '/controlroom/process/schedule/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 18,
      path: '/controlroom/process/schedule/history/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 57,
      path: '/controlroom/company/view',
      exact: true,
      component: Companies,
    },
    {
      key: 58,
      path: '/controlroom/company/details/:id',
      exact: true,
      component: CompanyDetails,
    },
    {
      key: 60,
      path: '/controlroom/groups',
      exact: true,
      component: Groups,
    },
    {
      key: 611,
      path: '/controlroom/group/registration',
      exact: true,
      component: GroupRegistration,
    },
    {
      key: 62,
      path: '/controlroom/groups/details/:id',
      exact: true,
      component: GroupDetails,
    },
    {
      key: 61,
      path: '/controlroom/profile',
      exact: true,
      component: ProfileDetails,
    },
    {
      key: 6,
      path: '/controlroom/process/:processDetails/:id',
      exact: true,
      component: ProcessLogsDetails,
    },
    {
      key: 612,
      path: '/controlroom/user',
      exact: true,
      component: ManageUsers,
    },
    {
    key: 111,
    path: '/controlroom/:companyId',
    exact: true,
    component: Dashboard,
    }
  ],
  [roles.CustomerAdmin]: [
    {
      key: 1,
      path: '/controlroom',
      exact: true,
      component: Dashboard,
    },
    {
      key: 2,
      path: '/controlroom/agents',
      exact: true,
      component: Agents,
    },
    {
      key: 4,
      path: '/controlroom/process',
      exact: true,
      component: ProcessCurrentStatus,
    },
    {
      key: 5,
      path: '/controlroom/process/logs',
      exact: true,
      component: HistoryLogs,
    },
    {
      key: 9,
      path: '/controlroom/bots/create',
      exact: true,
      component: CreateBot,
    },
    {
      key: 10,
      path: '/controlroom/bots/view',
      exact: true,
      component: ViewBots,
    },
    {
      key: 12,
      path: '/controlroom/user/view',
      exact: true,
      component: Users,
    },
    {
      key: 13,
      path: '/controlroom/user/details/:id',
      exact: true,
      component: UserDetails,
    },
    {
      key: 55,
      path: '/controlroom/user/registration',
      exact: true,
      component: UserRegistration,
    },
    {
      key: 15,
      path: '/controlroom/process/schedule/all',
      exact: true,
      component: ScheduledPlans,
    },
    {
      key: 16,
      path: '/controlroom/process/schedule/history',
      exact: true,
      component: ScheduledHistory,
    },
    {
      key: 17,
      path: '/controlroom/process/schedule/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 18,
      path: '/controlroom/process/schedule/history/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 60,
      path: '/controlroom/groups',
      exact: true,
      component: Groups,
    },
    {
      key: 63,
      path: '/controlroom/group/registration',
      exact: true,
      component: GroupRegistration,
    },
    {
      key: 62,
      path: '/controlroom/groups/details/:id',
      exact: true,
      component: GroupDetails,
    },
    {
      key: 61,
      path: '/controlroom/profile',
      exact: true,
      component: ProfileDetails,
    },
    {
      key: 6,
      path: '/controlroom/process/:processDetails/:id',
      exact: true,
      component: ProcessLogsDetails,
    },
    {
      key: 612,
      path: '/controlroom/user',
      exact: true,
      component: ManageUsers,
    },
  ],
  [roles.User]: [
    {
      key: 1,
      path: '/controlroom',
      exact: true,
      component: Dashboard,
    },
    {
      key: 2,
      path: '/controlroom/agents',
      exact: true,
      component: Agents,
    },
    {
      key: 4,
      path: '/controlroom/process',
      exact: true,
      component: ProcessCurrentStatus,
    },
    {
      key: 5,
      path: '/controlroom/process/logs',
      exact: true,
      component: HistoryLogs,
    },
    {
      key: 9,
      path: '/controlroom/bots/create',
      exact: true,
      component: CreateBot,
    },
    {
      key: 10,
      path: '/controlroom/bots/view',
      exact: true,
      component: ViewBots,
    },
    {
      key: 15,
      path: '/controlroom/process/schedule/all',
      exact: true,
      component: ScheduledPlans,
    },
    {
      key: 16,
      path: '/controlroom/process/schedule/history',
      exact: true,
      component: ScheduledHistory,
    },
    {
      key: 17,
      path: '/controlroom/process/schedule/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 18,
      path: '/controlroom/process/schedule/history/details/:id',
      exact: true,
      component: ScheduledPlanDetails,
    },
    {
      key: 61,
      path: '/controlroom/profile',
      exact: true,
      component: ProfileDetails,
    },
    {
      key: 6,
      path: '/controlroom/process/:processDetails/:id',
      exact: true,
      component: ProcessLogsDetails,
    },
  ],
  Common: [
    {
      key: 50,
      path: '/',
      exact: true,
      component: Home,
    },
  ],
};

export default routes;
